import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Box from 'ravenjs/lib/Box';
import KeyValuePairsNew from 'ravenjs/lib/KeyValuePairsNew';
import { getThemeProps } from 'ravenjs/utils/theme';
import { DEFAULT_COLORS } from 'constants/colors';

const DetailsSectionStyled = styled.div`
    ${getThemeProps('ObjectFieldTemplate.styles')};
`;

const TitleField = styled.label`
    color: #848484;
    font-size: 14px;
    font-family: Favorit;
    font-weight: 600;
    margin: 0 0 5px 10px;
    padding: 0;
`;

const DetailsSectionNew = ({ items, itemKey, itemValue, showDivider, title, boxProps }) => {
    const defaultBoxProps = {
        borderColor: DEFAULT_COLORS.PLACEHOLDER,
        borderRadius: '0',
    };

    return (
        <DetailsSectionStyled>
            <TitleField>{title}</TitleField>
            <Box {...defaultBoxProps} {...boxProps}>
                <KeyValuePairsNew
                    items={items}
                    itemKey={itemKey}
                    itemValue={itemValue}
                    keySuffix=" :"
                    showDivider={showDivider}
                />
            </Box>
        </DetailsSectionStyled>
    );
};

DetailsSectionNew.propTypes = {
    items: PropTypes.array,
    itemKey: PropTypes.string,
    itemValue: PropTypes.string,
    showDivider: PropTypes.bool,
    title: PropTypes.string,
    boxProps: PropTypes.object,
};

DetailsSectionNew.defaultProps = {
    items: [],
    itemKey: '',
    itemValue: '',
    showDivider: false,
    title: null,
    boxProps: null,
};

export default DetailsSectionNew;
